import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";

/** ========= MOCK opcional =========
 *  Ative com: REACT_APP_MOCK_BANNERS=1
 */
const delay = (ms = 200) => new Promise((r) => setTimeout(r, ms));
const isMock = typeof process !== "undefined" && process.env?.REACT_APP_MOCK_BANNERS === "1";

let MOCK_DB = [
  {
    id: 1,
    nome: "Hero – Peças originais",
    tipo: "carousel",
    ordem: 1,
    status: 1,
    eyebrow: "Peças Originais Scania",
    title: "Peças originais com segurança",
    subtitle: "Compre online com segurança, entrega rápida e condições especiais.",
    ctaLabel: "Ver catálogo",
    ctaHref: "/store",
    imageSrc: "/hero-bus.png",
    imageAlt: "Ônibus Scania branco",
    background: "#98999a",
  },
  {
    id: 2,
    nome: "Hero – Filtros",
    tipo: "carousel",
    ordem: 2,
    status: 1,
    eyebrow: "Promoção",
    title: "Filtros com até 20% OFF",
    subtitle: "Estoque limitado para linhas P, G e R.",
    ctaLabel: "Aproveitar",
    ctaHref: "/store?category=filtros",
    imageSrc: "/hero-filters.png",
    imageAlt: "Filtros de motor",
    background: "#98999a",
  },
  {
    id: 3,
    nome: "Card – 12x",
    tipo: "card",
    ordem: 3,
    status: 1,
    ctaHref: "/store?promo=12x",
    imageSrc: "/banners/ate-12x.png",
    imageAlt: "Ofertas especiais em até 12x",
    ratio: "1175/440",
    fit: "cover",
  },
];

const mockFetch = async (url, method = "GET", body) => {
  await delay();
  const q = Object.fromEntries(new URLSearchParams(url.split("?")[1] || ""));
  if (method === "GET") {
    const page = Math.max(1, Number(q.page) || 1);
    const limit = Math.max(1, Number(q.limit) || 50);
    const search = (q.search || "").toLowerCase();

    let list = MOCK_DB.slice();
    if (search) {
      list = list.filter((b) =>
        [
          b.nome,
          b.title,
          b.eyebrow,
          b.subtitle,
          b.tipo,
          b.ctaLabel,
          b.ctaHref,
        ]
          .filter(Boolean)
          .some((t) => String(t).toLowerCase().includes(search))
      );
    }
    list.sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
    const start = (page - 1) * limit;
    const slice = list.slice(start, start + limit);
    return { data: slice, pagination: { total: list.length, page, limit } };
  }
  if (method === "POST") {
    const nextId = MOCK_DB.length ? Math.max(...MOCK_DB.map((x) => x.id)) + 1 : 1;
    const created = { id: nextId, ...body };
    MOCK_DB.push(created);
    return { data: created };
  }
  if (method === "PUT") {
    const id = Number(url.split("/")[2]);
    const i = MOCK_DB.findIndex((x) => x.id === id);
    if (i >= 0) MOCK_DB[i] = { ...MOCK_DB[i], ...body };
    return { data: MOCK_DB[i] };
  }
  if (method === "DELETE") {
    const id = Number(url.split("/")[2]);
    MOCK_DB = MOCK_DB.filter((x) => x.id !== id);
    return { data: { success: true } };
  }
  throw new Error("mock: método não suportado");
};

const doFetch = (url, method = "GET", body) =>
  isMock ? mockFetch(url, method, body) : fetchData(url, method, body);
/** ========= /MOCK ========= */

export const useBanners = (page = 1, limit = 50, search = "") => {
  const queryClient = useQueryClient();

  const query = useQuery(
    ["banners", page, limit, search],
    () =>
      doFetch(`/banners?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`),
    {
      staleTime: 5000,
      refetchOnWindowFocus: false,
      select: (response) => ({
        banners: response?.data || [],
        pagination: response?.pagination || { total: 0 },
      }),
    }
  );

  const updateMutation = useMutation(
    (banner) => {
      const method = banner.id ? "PUT" : "POST";
      const endpoint = banner.id ? `/banners/${banner.id}` : `/banners`;
      return doFetch(endpoint, method, banner);
    },
    { onSuccess: () => queryClient.invalidateQueries("banners") }
  );

  const deleteMutation = useMutation(
    (id) => doFetch(`/banners/${id}`, "DELETE"),
    { onSuccess: () => queryClient.invalidateQueries("banners") }
  );

  return { ...query, updateMutation, deleteMutation };
};
